import {WEB_ROOT} from 'root/config';
import {OAUTH2_REDIRECT_URL} from 'paths';

export const loginStates = {
    ENTER_USERNAME: 'enter username',
    ENTER_PASSWORD: 'enter password',
    LOGGED_IN: 'logged in',
    EXTERNAL: 'external',
};

export const passwordResetStates = {
    ENTER_EMAIL: 'enter email',
    ENTER_CODE: 'enter code',
    ENTER_PASSWORDS: 'enter passwords',
    RESET_SUCCESS: 'reset success',
    RESET_FAILED: 'reset failed',
    RESET_CANCELLED: 'reset cancelled',
};

export const excessiveLoginAttempts = 3;

export const oauth2RedirectUrl = WEB_ROOT + OAUTH2_REDIRECT_URL.substring(1); // remove the preceding slash